import httpClient from './httpClient';

const conceptosAfectanLicenciaGoceHaberService = {
  obtenerConceptos: async (empresaId) => {
    try {
      const response = await httpClient.get(`/conceptos-afectan-licencia-goce-haber/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al obtener conceptos licencia con goce:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener la configuración',
        data: []
      };
    }
  },

  obtenerConceptosIngresosDisponibles: async () => {
    try {
      const response = await httpClient.get('/conceptos-afectan-licencia-goce-haber/conceptos-ingresos');
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al obtener conceptos de ingresos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener conceptos de ingresos',
        data: []
      };
    }
  },

  configurar: async (empresaId, conceptosIds) => {
    try {
      const response = await httpClient.post('/conceptos-afectan-licencia-goce-haber/configurar', {
        empresa_id: empresaId,
        conceptos_plame_ids: conceptosIds
      });
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Configuración guardada exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar configuración licencia goce:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al guardar configuración',
        errors: error.response?.data?.errors
      };
    }
  }
};

export default conceptosAfectanLicenciaGoceHaberService;
